import {DateRangeActiveRecord} from './active_record/base'

class AvailabilityShift extends DateRangeActiveRecord {
	static tableName = 'availabilityShifts'
	static startDateField = 'start_datetime'
	static endDateField = 'end_datetime'
}

export default AvailabilityShift
